package com.merkost.handpass.admin.di

import org.koin.core.context.startKoin
import org.koin.core.module.Module

fun startAdminKoin(extraModules: List<Module> = emptyList()) {
    startKoin {
        modules(repositoryModule + containerModule + extraModules)
    }
}
